import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ErrorMessage } from 'formik'
import { COLOR, FONT, GTR } from 'styles/tokens'

const StyledError = styled.div`
  color: ${COLOR.STATE.ERROR};
  font-size: ${FONT.SIZE.XS};
  margin-top: ${GTR.XXS};
`

const Error = ({ name }) => <ErrorMessage name={name} component={StyledError} />

Error.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Error
